import { createElement } from "./globalFunctions";

const footer = document.querySelector("#footer");

/**
 * Moves the footer bottom inside the footer bottom wrapper and inserts it after the footer.
 * Used for designs with different footer and footer-bottom backgrounds.
 */
const separateFooterBottom = () => {
  const footerBottom = document.querySelector(".footer-bottom");
  if (!footer || !footerBottom) return;

  const footerBottomWrapper = createElement("div", ["footer-bottom-wrapper"]);
  footerBottomWrapper.appendChild(footerBottom);
  footer.parentElement.insertBefore(
    footerBottomWrapper,
    footer.nextElementSibling
  );
};
const signature = document.querySelector(".footer-bottom #signature");

/**
 * Creates a signature with the MirandaMedia logo and text.
 * @param {string} logoUrl URL of the MirandaMedia logo
 */
// const createMirandaSignature = (logoUrl) => {
// 	if (!footer) return
// 	if (!signature) return
// 	signature.style.display = 'flex'
// 	const mirandaEl = createElement('a', ['miranda-signature'])
// 	mirandaEl.href = 'https://www.mirandamedia.cz/'
// 	mirandaEl.target = '_blank'
// 	mirandaEl.innerHTML = 'MirandaMedia Group s.r.o.'
// 	const mirandaLogoEl = createElement('img', ['miranda-logo'])
// 	// mirandaLogoEl.src = logoUrl
// 	mirandaLogoEl.src = 'https://cdn.myshoptet.com/usr/343520.myshoptet.com/user/documents/projects/libs/miranda_logo_green.png'
// 	mirandaLogoEl.alt = 'MirandaMedia'
// 	mirandaEl.prepend(mirandaLogoEl)
// 	signature.appendChild(mirandaEl)
// }

const createMirandaSignature = (logoUrl) => {
  if (!footer) return;
  if (!signature) return;
  signature.style.display = "flex";
  const mirandaEl = createElement("a", ["miranda-signature"]);
  mirandaEl.href = "https://www.mirandamedia.cz/";
  mirandaEl.target = "_blank";
  mirandaEl.innerHTML = `${
    window.language === "cs" ? "Vytvořila" : "Vytvorila"
  }<img class="miranda-logo" src="https://cdn.myshoptet.com/usr/343520.myshoptet.com/user/documents/projects/libs/miranda_logo_green.png" alt="MirandaMedia" width="24" height="19"/>  <strong>MirandaMedia Group s.r.o.</strong> `;

  signature.prepend(mirandaEl);
  const platformText = createElement("span", ["platform-text"]);
  platformText.textContent =
    window.language === "cs"
      ? "na platformě"
      : window.language === "sk"
      ? "na platforme"
      : window.language === "en"
      ? "on the platform"
      : window.language === "de"
      ? "auf der Plattform"
      : window.language === "fr"
      ? "sur la plateforme"
      : window.language === "it"
      ? "sulla piattaforma"
      : "";
  mirandaEl.after(platformText);
  const title = signature.querySelector(".title");
  if (title) title.textContent = " Shoptet Premium";
};
const createPaymentMethods = () => {
  if (signature) {
    signature.style.display = "flex";
    // 	const mirandaEl = document.createElement('a')
    // 	mirandaEl.href = 'https://www.mirandamedia.cz/'
    // 	mirandaEl.target = '_blank'
    // 	mirandaEl.innerHTML = 'Partner: MirandaMedia s.r.o.'
    // 	signature.appendChild(mirandaEl)
    const platebniMetodyEl = document.createElement("img");
    platebniMetodyEl.src = "/user/documents/upload/miranda/platebni_metody.png";
    platebniMetodyEl.alt = "Platební metody";
    platebniMetodyEl.width = 230;
    platebniMetodyEl.height = 20;
    signature.parentElement.insertBefore(
      platebniMetodyEl,
      signature.nextElementSibling
    );
  }
};
/**
 * Makes the footer headings clickable and toggles the active class.
 */
const makeFooterHeadingsClickable = () => {
  if (!footer) return;
  const footerHeadings = footer.querySelectorAll(".banner-wrapper > span > h4");
  for (const heading of footerHeadings) {
    heading.classList.add("clickable");
    heading.addEventListener("click", () => {
      heading.classList.toggle("active");
    });
  }
  const footerCategories = footer.querySelector(
    ".custom-footer__categories > h4"
  );
  if (footerCategories) {
    footerCategories.classList.add("clickable");
    footerCategories.addEventListener("click", () => {
      footerCategories
        .closest(".custom-footer__categories")
        .classList.toggle("active");
    });
  }
};
const clickableFooter = () => {
  if(!footer) return;
  const clickableHeadings = footer.querySelectorAll(
    ".custom-footer>div:not(.custom-footer__contact) h4"
  );
  if (clickableHeadings) {
    clickableHeadings.forEach((heading) => {
      heading.classList.add("clickable");
      heading.addEventListener("click", () => {
        heading.classList.toggle("active");
        const parentDiv = heading.closest("div");
        const parentElement = heading.closest("div.banner");
        if (parentDiv) {
          parentDiv.classList.toggle("active");
        }
        if (parentElement) {
          parentElement.classList.toggle("active");
        }
      });
    });
  }
};
const moveInstagram = () => {
  const instagram = document.querySelector(".custom-footer__instagram");
  if (!instagram) return;
  footer.before(instagram);
  instagram.classList.add("container");
  const instagramHeading = instagram.querySelector("h4");
  if (instagramHeading) {
    // instagramHeading.innerHTML = `
    // 	<span>
    // 		${window.language === 'cs' ? 'Instagramové příspěvky' : 'Instagramové príspevky'}
    // 	</span>
    // `
    if (typeof textSocials !== "undefined" && textSocials !== null) {
      instagramHeading.textContent = textSocials;
    }
  }
};
const addCopyrigthSignToFooterBottom = () => {
  const copyright = document.querySelector(".footer-bottom .copyright");
  if (copyright) {
    // console.log(copyright)
    copyright.innerHTML = copyright.innerHTML
      .replace("Copyright", "Copyright © ")
      .replace(".", " |");
  }
};
const footerLinksToBottom = () => {
  const footerLinks = document.querySelector(".footer-links-icons");
  if (!footerLinks) return;
  const footerBottom = document.querySelector(".footer-bottom-wrapper");
  if (!footerBottom) return;
  footerBottom.prepend(footerLinks);
};
export {
  separateFooterBottom,
  createMirandaSignature,
  moveInstagram,
  createPaymentMethods,
  addCopyrigthSignToFooterBottom,
  footerLinksToBottom,
  clickableFooter,
};
